import Joi from 'joi';

export const CancelSchema = Joi.object({
  canceledDate: Joi.date().required(),
  remark: Joi.string().required()
});

export const CancelAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
